export const MainVisualText1 = [
  'PPAPの代替手段として、Box共有リンクを利用し運用するために必要な仕組みをご提供します。',
  'オープンリンクを安全に組織内で運用することができるBoxエコソリューションサービスです。',
  'パスワードが設定されていないオープンリンクを検知して、自動的にパスワードを付与します。自動で付与されたパスワードは共有リンク作成者に通知します。',
  'GrantDriveで提供する拡張アプリにより、Box標準UIから直接パスワード付き共有リンクを送信することができます。PPAP代替となる共有リンクをメールで送信し、時間差でパスワードを送信します。',
  'Saas形式で提供するため、お客様側で特別なインフラ環境を用意する必要がありません。',
];
